<template>
  <div v-if="project != undefined" id="app-footer" style="clear: both">{{ copyright.value }}</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['project', 'copyright'])
  }
}
</script>

<style lang="scss" scoped>
#app-footer {
  height: 60px;
  width: 100%;
  background-color: #000;
  color: #fff;
  line-height: 60px;
}
</style>
